const isAdmin = (state = false, action) => {
  switch (action.type) {
    case "SET_IS_ADMIN":
      return action.isAdmin;
    case "LOG_OUT":
      return false;
    default:
      return state;
  }
};

export default isAdmin;
